import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { translateMessage } from "functions";
import FieldBlock from "components/FieldBlock/FieldBlock";
import useFetchApi from "hooks/useFetchApi";

export default function FieldBlockCheckbox({
  label,
  name,
  value,
  id,
  route,
  sectionID,
  editAll,
  updateGroupAnswers,
  fetchData,
  readonly,
}) {
  const [fetchApi] = useFetchApi();
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [answer, setAnswer] = useState(!!value);
  const [fieldError, setFieldError] = useState();

  const onSubmit = async () => {
    setLoading(true);
    document.activeElement?.blur();
    const body = route
      ? { [route]: { [name]: answer, id: sectionID } }
      : { [name]: answer };
    try {
      setFieldError(null);
      await fetchApi(`update-dossier/${id}`, { body, method: "PUT" });
      fetchData();
      setEditing(false);
    } catch ({ message }) {
      setFieldError(translateMessage(message));
    }
    setLoading(false);
  };

  const onCancel = () => {
    setEditing(!editing);
    setAnswer(value || false);
  };

  const handleAnswer = (item) => {
    setAnswer(item);
    updateGroupAnswers(name, item, route, sectionID);
  };

  useEffect(() => {
    setAnswer(!!value);
  }, [value]);

  useEffect(() => {
    if (!editAll) {
      setEditing(false);
    }
  }, [editAll]);

  useEffect(() => {
    if (!editing) {
      setFieldError(null);
    }
  }, [editing]);

  const contents = (
    <label className="text-xs flex items-center">
      <input
        type="checkbox"
        checked={!!answer}
        disabled={(!editing && !editAll) || loading} // Disable the checkbox when not editing
        onChange={() => {
          setAnswer(!answer);
          if (editAll) {
            handleAnswer(!answer);
          }
        }}
      />
      <span className="ml-2">{label}</span>
    </label>
  );

  return (
    <FieldBlock
      displayValue={contents}
      loading={loading}
      editing={editing}
      editAll={editAll}
      readonly={readonly}
      onSubmit={onSubmit}
      onCancel={onCancel}
      setEditing={setEditing}
    >
      {contents}
      {fieldError && <p className="text-xs text-red-500">{fieldError}</p>}
    </FieldBlock>
  );
}
FieldBlockCheckbox.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.bool,
  id: PropTypes.number,
  route: PropTypes.string,
  sectionID: PropTypes.number,
  readonly: PropTypes.bool,
  editAll: PropTypes.bool,
  updateGroupAnswers: PropTypes.func,
  fetchData: PropTypes.func,
};
